import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-burial-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-burial-details-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewBurialDetailsCmConstants } from "./view-burial-details-cm.constants";
import { SaShortDatePipe } from "../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
export let ViewBurialDetailsCmComponent = class ViewBurialDetailsCmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    saShortdatePipe;
    routerParamsService;
    burialTypeControl = ViewBurialDetailsCmConstants.BURIAL_TYPE_CONTROL;
    burialTypeLabel = ViewBurialDetailsCmConstants.BURIAL_TYPE_LABEL;
    burialDateControl = ViewBurialDetailsCmConstants.BURIAL_DATE_CONTROL;
    burialDateLabel = ViewBurialDetailsCmConstants.BURIAL_DATE_LABEL;
    burialTypePlaceHolder = ViewBurialDetailsCmConstants.BURIAL_TYPE_PH;
    validationMessages = ViewBurialDetailsCmConstants.VALIDATION_MESSAGES;
    burialDescriptionControl = ViewBurialDetailsCmConstants.DESCRIPTION_CONTROL;
    burialDescriptionLabel = ViewBurialDetailsCmConstants.DESCRIPTION_LABEL;
    title = ViewBurialDetailsCmConstants.STEP_TITLE;
    burialTypes = [];
    detailsForm;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, saShortdatePipe, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.saShortdatePipe = saShortdatePipe;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.loadLookup();
        this.initForm();
        this.getMetadata();
        this.populateForm(this.selectedApplication);
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("burialForm");
    }
    populateForm(application) {
        this.detailsForm.get(this.burialTypeControl).setValue(application.type);
        this.detailsForm.get(this.burialDescriptionControl).setValue(application.description);
        this.detailsForm.get(this.burialDescriptionControl).disable();
        this.detailsForm.get(this.burialTypeControl).disable();
        const date = application.burialDate ? application.burialDate : new Date();
        const dateString = this.saShortdatePipe.transform(date);
        this.detailsForm.get(this.burialDateControl).setValue(dateString);
        this.detailsForm.get(this.burialDateControl).disable();
    }
    loadLookup() {
        this.cleanupAfterDestroy(this.applicationViewService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'ApplicationType' and deleted eq false` })).subscribe(lookupValues => {
            const lookup = lookupValues.value;
            lookup.forEach(lp => {
                this.burialTypes.push(JSON.parse(lp.content));
            });
            this.changeDetectorRefs.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SaShortDatePipe },
        { type: RouterParamsService }
    ];
};
ViewBurialDetailsCmComponent = __decorate([
    Component({
        selector: "app-view-burial-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewBurialDetailsCmComponent);
